<template lang="html">
  <full-screen @close="$emit('close')">
    <div class="tc">
      <div class="ma3 flex justify-center pl-title">
        <p v-if="page === 'course-selection'" class="b">
          What course is this RoundTable for?
        </p>
        <p v-if="page === 'online-live'" class="b">What type of RoundTable?</p>
        <p v-if="page === 'universe-create-own'" class="b">
          How would you like to start?
        </p>
      </div>
      <transition-group name="choose-activity-appear-enter-only">
        <!-- Choose Course Section -->
        <div key="course-selection" v-if="page === 'course-selection'" class="">
          <!-- Course List -->
          <div
            v-for="(course, index) in courses_I_teach"
            class="flex flex-nowrap items-center h3 ph3 course-row center-xs center col-xs-9"
            :key="course.id"
          >
            <div
              @click="handleSelectCourse(course.id)"
              class="grow flex flex-nowrap items-center h3 ph3 clickable flex-grow course-item-content start-xs"
            >
              <div class="flex-grow pl-subheading">
                {{ course.title }}
                {{ course.sections[0] ? ' - ' + course.sections[0] : '' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Choose Live or Online Section -->
        <section
          key="live-online"
          v-if="page === 'online-live'"
          class="choose-universe-live-online h-auto flex flex-wrap"
        >
          <div class="flex-grow tc">
            <div
              @click="selectOnline"
              class="ma3 grow justify-center choose-activity-btn clickable"
            >
              <img
                src="/static/online_roundtable_icons/online.svg"
                alt="written roundtable"
                style="height: 95px"
              />
              <div class="b mt3 f4">Written</div>
              <div class="pl-caption pv2 mv2">
                A tool for written blended discussions and collaboration.
              </div>
              <div class="pill pl-caption">Create Written RoundTable</div>
            </div>
          </div>
          <div class="flex-grow tc">
            <div
              @click="createLive"
              class="ma3 grow justify-center choose-activity-btn clickable"
            >
              <img
                src="/static/live_discussion/live.svg"
                alt="verbal discussion"
                style="height: 95px"
              />
              <div class="b mt3 f4">Verbal</div>
              <div class="pl-caption pv2 mv2">
                A tool for facilitating and tracking face-to-face discussions.
              </div>
              <div class="pill pl-caption">Create Verbal RoundTable</div>
            </div>
          </div>

          <!-- Passes Section -->
          <div
            v-if="!getProfile.is_paid"
            style="background-color: #edf1f7"
            class="center pl-title w-80 pa3"
          >
            You have
            <span class="ruby"
              >{{ getProfile.activity_passes }} roundtables</span
            >
            in your free trial. <br />
            <span @click="openUpgradeOverlay" class="clickable b"
              >Click here</span
            >
            to upgrade.
          </div>
        </section>

        <!-- Create Online Options -->
        <section
          key="universe-create-own"
          v-else-if="page === 'universe-create-own'"
          class="choose-universe-create-own h-auto flex center-xs flex-wrap"
        >
          <div class="flex-grow tc">
            <div
              @click="goToUniverse"
              class="ma3 grow justify-center choose-activity-btn clickable"
            >
              <img
                src="/static/science.svg"
                alt="parlay universe"
                style="height: 95px"
              />
              <div class="b mt3 f4">Parlay Universe</div>
              <div class="pl-caption pv2 mv2">
                Browse Parlay's library of discussion topics.
              </div>
              <div class="pill pl-caption">Browse Universe</div>
            </div>
          </div>
          <div class="flex-grow tc">
            <div
              @click="goToMyPortfolio"
              class="ma3 grow justify-center choose-activity-btn clickable"
            >
              <img
                :src="getProfile.avatar_url"
                alt="easel"
                style="
                  height: 95px;
                  width: 95px;
                  border-radius: 50%;
                  align-self: center;
                "
              />
              <div class="b mt3 f4">My Portfolio</div>
              <div class="pl-caption pv2 mv2">
                Your personal portfolio of discussion topics.
              </div>
              <div class="pill pl-caption">Browse Portfolio</div>
            </div>
          </div>
          <div class="flex-grow tc">
            <div
              @click="createOnline"
              class="ma3 grow justify-center choose-activity-btn clickable"
            >
              <img src="/static/easel.svg" alt="easel" style="height: 95px" />
              <div class="b mt3 f4">Create My Own</div>
              <div class="pl-caption pv2 mv2">
                Start from scratch or use an instructional template.
              </div>
              <div class="pill pl-caption">Start from Scratch</div>
            </div>
          </div>
          <pl-button
            key="back"
            v-show="page === 'universe-create-own'"
            @click.native="page = 'online-live'"
            class="pl-ruby-font pl-border"
            >Back
          </pl-button>
        </section>
      </transition-group>
    </div>
  </full-screen>
</template>

<script>
  import FullScreen from 'components/fullscreenOverlay';
  import URLconfigs from 'services/apiConfigs';
  import { EventBus } from 'utils/event-bus';
  import get from 'lodash/get';
  import { mapGetters } from 'vuex';
  import theParlayTemplate from 'components/textEditor/templates/theParlayTemplate';
  import profileServices from 'services/profile/profileServices';
  import accountService from 'services/account';
  import authenticationServices from 'features/authentication/authentication.services';

  export default {
    data() {
      return {
        page: 'online-live', // 'online-live', 'universe-create-own', 'course-selection'
        selected_course_id: null,
      };
    },
    components: {
      FullScreen,
    },
    mounted() {
      if (this.courseID) {
        this.selected_course_id = this.courseID;
      } else {
        this.page = 'course-selection';
      }
    },
    props: {
      courseID: {
        type: String,
        default: null,
      },
    },
    computed: {
      ...mapGetters(['getProfile', 'getCourses', 'getCourseDetail']),
      can_create_activities() {
        return Boolean(
          this.getProfile.is_paid || this.getProfile.activity_passes
        );
      },
      courses_I_teach() {
        return this.getCourses.filter((course) => {
          const role = get(course, 'users[0].subscription.role');
          return ['author', 'co-teacher'].includes(role);
        });
      },
    },
    methods: {
      handleSelectCourse(course_id) {
        if (course_id) {
          this.selected_course_id = course_id;
          this.page = 'online-live';
        }
      },
      openUpgradeOverlay() {
        EventBus.$emit('open-upgrade-modal');
        this.$emit('close');
      },

      goToUniverse() {
        const course_url = `${URLconfigs.universeURL}/roundtables/browse?course_id=${this.selected_course_id}`;
        authenticationServices.navigateToExternalWithAuth(course_url);
      },
      goToMyPortfolio() {
        if (!this.getProfile.profile_url) {
          profileServices
            .createProfile(this.getProfile.id)
            .then(({ data }) => {
              const profile_url = `${URLconfigs.universeURL}/profiles/${data.profile_url}`;
              authenticationServices.navigateToExternalWithAuth(profile_url);

              return accountService
                .completeInfo()
                .then((res) => this.$store.dispatch('setAccount', res.data));
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          const profile_url = `${URLconfigs.universeURL}/profiles/${this.getProfile.profile_url}`;
          authenticationServices.navigateToExternalWithAuth(profile_url);
        }
      },
      selectOnline() {
        if (!this.can_create_activities) {
          return this.openUpgradeOverlay();
        }
        this.page = 'universe-create-own';
      },
      createLive() {
        if (!this.can_create_activities) {
          return this.openUpgradeOverlay();
        }
        this.$store.dispatch(
          'analytics',
          'create verbal discussion - create verbal discussion'
        );
        this.$store.dispatch('setRTLoading', true);
        this.$store
          .dispatch('createLiveDiscussion', {
            courseID: this.selected_course_id,
          })
          .then(() => {
            this.$emit('close');
            if (this.getCourseDetail.live_discussions.length === 1) {
              EventBus.$emit('showWelcomeLiveRT');
            }
          })
          .catch((err) => {
            console.error(err);
            this.$store.dispatch('setRTLoading', false);
          });
      },
      createOnline() {
        const prompt = theParlayTemplate.prompt;
        this.$store.dispatch(
          'analytics',
          'create written roundtable - create written roundtable'
        );
        this.$store
          .dispatch('createOnlineRoundtable', {
            course_id: this.selected_course_id,
            title: 'RoundTable',
            prompt,
            user_created: true,
          })
          .then(() => {
            this.$emit('close');
          })
          .catch(console.error);
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  // *
  //   outline: 1px solid red
  .ruby
    color: pl-ruby
  .choose-activity-btn
    width: 250px;
    margin: 2em auto;
    padding: 2em 1em;
    &:hover
      box-shadow: 2px 2px 16px 4px rgba( 0, 0, 0, 0.2 );
  .pill
    border: 1px solid pl-secondary
    border-radius: 2em
    align-self: center
    padding: 0.5em 1em
    color: pl-secondary
    font-weight: bold
  .choose-activity-appear-enter-only-enter-active
    transition: all .6s ease
  .choose-activity-appear-enter-only-leave-active
    display: none
  .choose-activity-appear-enter-only-enter, .choose-activity-appear-enter-only-leave-to
    opacity: 0

  .course-row
    border-bottom: 1px solid pl-fog
    .course-item-content
      &:hover
        background-color: pl-fog
    &:last-child
      border-bottom: none
</style>



// WEBPACK FOOTER //
// fullScreenChooseActivity.vue?0c8fdc42